import { Platform } from 'react-native';
import { createIndexedDBInterface } from './indexedDB';
import { getOrders, getScanBarCode, saveOrders, saveScanBarcode } from './apiStorage';

// Only import SQLite and FileSystem for native platforms
let SQLite, FileSystem;
if (Platform.OS !== 'web') {
  SQLite = require('expo-sqlite');
  FileSystem = require('expo-file-system');
}

let db;

if (Platform.OS === 'web') {
  // Use IndexedDB interface for web
  db = createIndexedDBInterface();
} else {
  // Native SQLite implementation
  const dbDirectory = FileSystem.documentDirectory + 'SQLite/';
  
  // Ensure directory exists
  FileSystem.makeDirectoryAsync(dbDirectory, { intermediates: true })
    .catch(error => console.log('Directory exists or error:', error));
    
  db = SQLite.openDatabase('api_responses.db');
}

// Initialize database tables
export const initDatabase = () => {
  return new Promise((resolve, reject) => {
    try {
      db.transaction(
        (tx) => {
          // These won't actually create tables in IndexedDB (web),
          // but the code is kept for API compatibility
          tx.executeSql(
            'CREATE TABLE IF NOT EXISTS scan_barcode (id INTEGER PRIMARY KEY, data TEXT, timestamp INTEGER);',
            []
          );
          
          tx.executeSql(
            'CREATE TABLE IF NOT EXISTS users (id INTEGER PRIMARY KEY, data TEXT, timestamp INTEGER);',
            []
          );
          
          tx.executeSql(
            'CREATE TABLE IF NOT EXISTS orders (id INTEGER PRIMARY KEY, data TEXT, timestamp INTEGER);',
            []
          );
          
          tx.executeSql(
            'CREATE TABLE IF NOT EXISTS products (id INTEGER PRIMARY KEY, data TEXT, timestamp INTEGER);',
            []
          );
          
          tx.executeSql(
            'CREATE TABLE IF NOT EXISTS settings (id INTEGER PRIMARY KEY, data TEXT, timestamp INTEGER);',
            []
          );
        },
        (error) => {
          console.log('Database initialization error:', error);
          reject(error);
        },
        () => {
          console.log('Database initialized successfully');
          resolve();
        }
      );
    } catch (outerError) {
      console.error('Outer database initialization error:', outerError);
      reject(outerError);
    }
  });
};

export default db;

export const updateBarcodeName = async (orders) => {
  // 1. Get the current data
  const scanBarCodeData = await getScanBarCode();

  // 2. Check if data exists
  if (!scanBarCodeData) {
    throw new Error('No scan barcode data found to modify');
  }

  // 3. Modify the data
  const updatedData = {...orders};

  // 4. Save updated data
  await saveScanBarcode(updatedData);

  // 5. Return updated data
  return updatedData;
};
